// extracted by mini-css-extract-plugin
module.exports = {"container":"container--jhGi42yW","content":"content--BFxEtXzU"};